import { ClienteModel } from './cliente.model';

export class UnidadeGestoraModel {
  id: number;
  descricao: string;
  sigla: string;
  cliente: ClienteModel;
}



// WEBPACK FOOTER //
// /app/src/app/model/cliente/unidadegestora.ts